(() => {
  const root = document.getElementById('MrWelcomePopup');
  if (!root) return;

  const storageKey = 'mr_welcome5_claimed';
  const dismissKey = 'mr_welcome5_dismissed';
  const code = (root.dataset.code || 'WELCOME5').trim().toUpperCase();
  const delay = Math.max(1, Number(root.dataset.delay) || 3) * 1000;
  const claimButton = root.querySelector('[data-welcome-claim]');
  const note = root.querySelector('[data-welcome-note]');
  const codeWrap = root.querySelector('[data-welcome-code-wrap]');
  const dialog = root.querySelector('.mr-welcome__dialog');

  const claimed = () => {
    try {
      return window.localStorage.getItem(storageKey) === code;
    } catch (error) {
      return document.cookie.includes('mr_welcome5=1');
    }
  };

  const recentlyDismissed = () => {
    try {
      const raw = window.localStorage.getItem(dismissKey);
      if (!raw) return false;
      return Date.now() - Number(raw) < 14 * 24 * 60 * 60 * 1000;
    } catch (error) {
      return false;
    }
  };

  const persistClaim = () => {
    try {
      window.localStorage.setItem(storageKey, code);
    } catch (error) {
      document.cookie = 'mr_welcome5=1; max-age=31536000; path=/';
    }
  };

  const persistDismiss = () => {
    try {
      window.localStorage.setItem(dismissKey, String(Date.now()));
    } catch (error) {
      document.cookie = 'mr_welcome5_dismissed=1; max-age=1209600; path=/';
    }
  };

  const open = () => {
    root.hidden = false;
    document.body.classList.add('mr-welcome-open');
    requestAnimationFrame(() => root.classList.add('is-open'));
    dialog?.focus();
  };

  const close = () => {
    root.classList.remove('is-open');
    document.body.classList.remove('mr-welcome-open');
    root.hidden = true;
  };

  const applyDiscount = async () => {
    persistClaim();
    codeWrap.hidden = false;
    if (claimButton) {
      claimButton.disabled = true;
      claimButton.textContent = 'Applying…';
    }

    try {
      await fetch(`${window.routes?.cart_update_url || '/cart/update.js'}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code }),
      });
    } catch (error) {
      // Shopify still accepts /discount/CODE as the reliable apply path.
    }

    if (note) {
      note.textContent = `${code} will be applied at checkout.`;
    }

    const redirect = `${window.location.pathname}${window.location.search}`;
    window.location.assign(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}`);
  };

  root.querySelectorAll('[data-welcome-dismiss]').forEach((el) => {
    el.addEventListener('click', () => {
      persistDismiss();
      close();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root.classList.contains('is-open')) {
      persistDismiss();
      close();
    }
  });

  claimButton?.addEventListener('click', applyDiscount);

  if (claimed() || recentlyDismissed()) return;
  window.setTimeout(open, delay);
})();
